import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faSave, 
  faCog, 
  faSearch, 
  faEye,
  faShield,
  faPalette,
  faGlobe,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import '../styles/AdminSettings.css';

const AdminSettings = () => {
  const [settings, setSettings] = useState({
    // SEO Settings
    siteTitle: 'MAnime - Xem Anime Online Miễn Phí',
    siteDescription: 'Trang web xem anime online miễn phí với chất lượng cao, phụ đề tiếng Việt',
    siteKeywords: 'anime, xem anime, anime online, anime vietsub, hoạt hình',
    siteLogo: '/logo.png',
    siteFavicon: '/favicon.ico',
    
    // General Settings
    siteName: 'MAnime',
    siteUrl: 'https://manime.com',
    adminEmail: 'admin@manime.com',
    supportEmail: 'support@manime.com',
    
    // Features
    enableRegistration: true,
    enableComments: true,
    enableRatings: true,
    enableFavorites: true,
    enableSearch: true,
    enableNotifications: true,
    
    // Display Settings
    itemsPerPage: 20,
    enableDarkMode: true,
    defaultTheme: 'auto',
    
    // Player Settings
    defaultQuality: 'auto',
    autoPlay: false,
    showSkipIntro: true,
    
    // Security
    enableCaptcha: false,
    maxLoginAttempts: 5,
    sessionTimeout: 24, // hours
    
    // Analytics
    googleAnalyticsId: '',
    enableAnalytics: false,
    
    // Social Media
    facebookUrl: '',
    twitterUrl: '',
    youtubeUrl: '',
    discordUrl: ''
  });

  const [activeTab, setActiveTab] = useState('general');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    // Load settings from localStorage or API
    const savedSettings = localStorage.getItem('adminSettings');
    if (savedSettings) {
      setSettings(JSON.parse(savedSettings));
    }
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Save to localStorage (in real app, this would be API call)
      localStorage.setItem('adminSettings', JSON.stringify(settings));
      
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (error) {
      console.error('Error saving settings:', error);
    } finally {
      setSaving(false);
    }
  };

  const handleInputChange = (key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const tabs = [
    { id: 'general', label: 'Chung', icon: faCog },
    { id: 'seo', label: 'SEO', icon: faSearch },
    { id: 'features', label: 'Tính năng', icon: faEye },
    { id: 'appearance', label: 'Giao diện', icon: faPalette },
    { id: 'security', label: 'Bảo mật', icon: faShield },
    { id: 'social', label: 'Mạng xã hội', icon: faGlobe }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'general':
        return (
          <div className="settings-section">
            <h3>Cài đặt chung</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Tên website</label>
                <input
                  type="text"
                  value={settings.siteName}
                  onChange={(e) => handleInputChange('siteName', e.target.value)}
                />
              </div>
              
              <div className="form-group">
                <label>URL website</label>
                <input
                  type="url"
                  value={settings.siteUrl}
                  onChange={(e) => handleInputChange('siteUrl', e.target.value)}
                />
              </div>
              
              <div className="form-group">
                <label>Email Admin</label>
                <input
                  type="email"
                  value={settings.adminEmail}
                  onChange={(e) => handleInputChange('adminEmail', e.target.value)}
                />
              </div>
              
              <div className="form-group">
                <label>Email hỗ trợ</label>
                <input
                  type="email"
                  value={settings.supportEmail}
                  onChange={(e) => handleInputChange('supportEmail', e.target.value)}
                />
              </div>
              
              <div className="form-group">
                <label>Số item mỗi trang</label>
                <select
                  value={settings.itemsPerPage}
                  onChange={(e) => handleInputChange('itemsPerPage', parseInt(e.target.value))}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={50}>50</option>
                </select>
              </div>
            </div>
          </div>
        );

      case 'seo':
        return (
          <div className="settings-section">
            <h3>Cài đặt SEO</h3>
            <div className="form-grid">
              <div className="form-group full-width">
                <label>Tiêu đề website</label>
                <input
                  type="text"
                  value={settings.siteTitle}
                  onChange={(e) => handleInputChange('siteTitle', e.target.value)}
                  placeholder="Tiêu đề xuất hiện trên tab trình duyệt"
                />
              </div>
              
              <div className="form-group full-width">
                <label>Mô tả website</label>
                <textarea
                  value={settings.siteDescription}
                  onChange={(e) => handleInputChange('siteDescription', e.target.value)}
                  rows={3}
                  placeholder="Mô tả ngắn về website"
                />
              </div>
              
              <div className="form-group full-width">
                <label>Từ khóa</label>
                <input
                  type="text"
                  value={settings.siteKeywords}
                  onChange={(e) => handleInputChange('siteKeywords', e.target.value)}
                  placeholder="Các từ khóa cách nhau bằng dấu phẩy"
                />
              </div>
              
              <div className="form-group">
                <label>Google Analytics ID</label>
                <input
                  type="text"
                  value={settings.googleAnalyticsId}
                  onChange={(e) => handleInputChange('googleAnalyticsId', e.target.value)}
                  placeholder="GA-XXXXXXXXX"
                />
              </div>
              
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={settings.enableAnalytics}
                    onChange={(e) => handleInputChange('enableAnalytics', e.target.checked)}
                  />
                  Bật Google Analytics
                </label>
              </div>
            </div>
          </div>
        );

      case 'features':
        return (
          <div className="settings-section">
            <h3>Quản lý tính năng</h3>
            <div className="feature-grid">
              <div className="feature-item">
                <div className="feature-info">
                  <h4>Đăng ký thành viên</h4>
                  <p>Cho phép người dùng tạo tài khoản mới</p>
                </div>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={settings.enableRegistration}
                    onChange={(e) => handleInputChange('enableRegistration', e.target.checked)}
                  />
                  <span className="slider"></span>
                </label>
              </div>
              
              <div className="feature-item">
                <div className="feature-info">
                  <h4>Bình luận</h4>
                  <p>Cho phép người dùng bình luận trên các bộ phim</p>
                </div>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={settings.enableComments}
                    onChange={(e) => handleInputChange('enableComments', e.target.checked)}
                  />
                  <span className="slider"></span>
                </label>
              </div>
              
              <div className="feature-item">
                <div className="feature-info">
                  <h4>Đánh giá</h4>
                  <p>Cho phép người dùng đánh giá phim</p>
                </div>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={settings.enableRatings}
                    onChange={(e) => handleInputChange('enableRatings', e.target.checked)}
                  />
                  <span className="slider"></span>
                </label>
              </div>
              
              <div className="feature-item">
                <div className="feature-info">
                  <h4>Yêu thích</h4>
                  <p>Cho phép người dùng lưu phim yêu thích</p>
                </div>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={settings.enableFavorites}
                    onChange={(e) => handleInputChange('enableFavorites', e.target.checked)}
                  />
                  <span className="slider"></span>
                </label>
              </div>
              
              <div className="feature-item">
                <div className="feature-info">
                  <h4>Tìm kiếm</h4>
                  <p>Cho phép tìm kiếm phim</p>
                </div>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={settings.enableSearch}
                    onChange={(e) => handleInputChange('enableSearch', e.target.checked)}
                  />
                  <span className="slider"></span>
                </label>
              </div>
              
              <div className="feature-item">
                <div className="feature-info">
                  <h4>Thông báo</h4>
                  <p>Gửi thông báo đến người dùng</p>
                </div>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={settings.enableNotifications}
                    onChange={(e) => handleInputChange('enableNotifications', e.target.checked)}
                  />
                  <span className="slider"></span>
                </label>
              </div>
            </div>
          </div>
        );

      case 'appearance':
        return (
          <div className="settings-section">
            <h3>Cài đặt giao diện</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Chế độ mặc định</label>
                <select
                  value={settings.defaultTheme}
                  onChange={(e) => handleInputChange('defaultTheme', e.target.value)}
                >
                  <option value="light">Sáng</option>
                  <option value="dark">Tối</option>
                  <option value="auto">Tự động</option>
                </select>
              </div>
              
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={settings.enableDarkMode}
                    onChange={(e) => handleInputChange('enableDarkMode', e.target.checked)}
                  />
                  Cho phép chế độ tối
                </label>
              </div>
              
              <div className="form-group">
                <label>Chất lượng video mặc định</label>
                <select
                  value={settings.defaultQuality}
                  onChange={(e) => handleInputChange('defaultQuality', e.target.value)}
                >
                  <option value="auto">Tự động</option>
                  <option value="1080p">1080p</option>
                  <option value="720p">720p</option>
                  <option value="480p">480p</option>
                </select>
              </div>
              
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={settings.autoPlay}
                    onChange={(e) => handleInputChange('autoPlay', e.target.checked)}
                  />
                  Tự động phát video
                </label>
              </div>
              
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={settings.showSkipIntro}
                    onChange={(e) => handleInputChange('showSkipIntro', e.target.checked)}
                  />
                  Hiển thị nút bỏ qua intro
                </label>
              </div>
            </div>
          </div>
        );

      case 'security':
        return (
          <div className="settings-section">
            <h3>Cài đặt bảo mật</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Số lần đăng nhập sai tối đa</label>
                <input
                  type="number"
                  min="1"
                  max="10"
                  value={settings.maxLoginAttempts}
                  onChange={(e) => handleInputChange('maxLoginAttempts', parseInt(e.target.value))}
                />
              </div>
              
              <div className="form-group">
                <label>Thời gian hết hạn session (giờ)</label>
                <input
                  type="number"
                  min="1"
                  max="168"
                  value={settings.sessionTimeout}
                  onChange={(e) => handleInputChange('sessionTimeout', parseInt(e.target.value))}
                />
              </div>
              
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={settings.enableCaptcha}
                    onChange={(e) => handleInputChange('enableCaptcha', e.target.checked)}
                  />
                  Bật CAPTCHA
                </label>
              </div>
            </div>
          </div>
        );

      case 'social':
        return (
          <div className="settings-section">
            <h3>Liên kết mạng xã hội</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Facebook URL</label>
                <input
                  type="url"
                  value={settings.facebookUrl}
                  onChange={(e) => handleInputChange('facebookUrl', e.target.value)}
                  placeholder="https://facebook.com/yourpage"
                />
              </div>
              
              <div className="form-group">
                <label>Twitter URL</label>
                <input
                  type="url"
                  value={settings.twitterUrl}
                  onChange={(e) => handleInputChange('twitterUrl', e.target.value)}
                  placeholder="https://twitter.com/youraccount"
                />
              </div>
              
              <div className="form-group">
                <label>YouTube URL</label>
                <input
                  type="url"
                  value={settings.youtubeUrl}
                  onChange={(e) => handleInputChange('youtubeUrl', e.target.value)}
                  placeholder="https://youtube.com/yourchannel"
                />
              </div>
              
              <div className="form-group">
                <label>Discord URL</label>
                <input
                  type="url"
                  value={settings.discordUrl}
                  onChange={(e) => handleInputChange('discordUrl', e.target.value)}
                  placeholder="https://discord.gg/yourserver"
                />
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="admin-settings">
      <div className="settings-header">
        <h2 className="settings-title">
          <FontAwesomeIcon icon={faCog} />
          Thiết lập hệ thống
        </h2>
        <button 
          className={`save-button ${saving ? 'loading' : ''} ${saved ? 'saved' : ''}`}
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? (
            <>
              Đang lưu...
            </>
          ) : saved ? (
            <>
              <FontAwesomeIcon icon={faCheck} />
              Đã lưu
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faSave} />
              Lưu cài đặt
            </>
          )}
        </button>
      </div>

      <div className="settings-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <FontAwesomeIcon icon={tab.icon} />
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="settings-content">
        {renderTabContent()}
      </div>

      {saved && (
        <div className="saved-indicator">
          <FontAwesomeIcon icon={faCheck} />
          Cài đặt đã được lưu thành công!
        </div>
      )}
    </div>
  );
};

export default AdminSettings;